<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="title">基本信息：</div>
      <el-form
        ref="dialogForm"
        :model="dialogForm"
        :rules="formRule"
        label-width="120px"
      >
        <el-form-item label="供应商名称" prop="user_name">
          <el-input
            style="width: 220px"
            v-model="dialogForm.user_name"
            placeholder="请输入供应商名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="供应商联系人" prop="contacts">
          <el-input
            style="width: 220px"
            v-model="dialogForm.contacts"
            placeholder="请输入供应商联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="供应商联系电话" prop="tel">
          <el-input
            style="width: 220px"
            v-model="dialogForm.tel"
            placeholder="请输入供应商联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="供应商地址" prop="address">
          <el-input
            style="width: 220px"
            v-model="dialogForm.address"
            placeholder="请输入供应商地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="生效状态" prop="status">
          <el-switch v-model="dialogForm.status">
          </el-switch>
        </el-form-item>
        <div class="titlas">
          <span class="title">写码软件账号信息</span>
        </div>
        <el-form-item label="登录账号" prop="key">
          <el-input
            style="width: 220px"
            v-model="dialogForm.key"
            placeholder="请输入账号信息"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <span class="dialog-footer">
            <el-button @click="reset">取消</el-button>
            <el-button type="primary" @click="submitForm('dialogForm')">提交</el-button>
          </span>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { createSupApi, updateSup } from "@/api/radio"

export default {
  data() {
    return {
      formRule: {
        user_name: {
          required: true,
          message: "请输入供应商名称",
          trigger: "blur",
        },
        contacts: {
          required: true,
          message: "请输入供应商联系人",
          trigger: "blur",
        },
        tel: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { 
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: ['blur', 'change']
          }
        ],
        address: {
          required: true,
          message: "请输入供应商地址",
          trigger: "blur",
        },
        key: {
          required: true,
          message: "请输入账号信息",
          trigger: "blur",
        },
      },
      queryForm: {
        page: 1,
        pageSize: 10,
      },
      dialogForm: {
        user_name: '',
        key: '',
        password: '123456789',
        address: '',
        tel: '',
        status: true,
        contacts: ''
      }, // 模态框展示的数据
      tableData: [],
      type: '',
      id: null
    };
  },
  created() {
    this.type = this.$route.query.type
    if(this.type == 'edit'){
      // let param = JSON.parse(this.$route.query.row)
      let param = JSON.parse(sessionStorage.getItem('supplier'))
      this.id = param.id
      this.dialogForm.user_name = param.user_name
      this.dialogForm.key = param.key
      this.dialogForm.password = param.password
      this.dialogForm.address = param.address
      this.dialogForm.tel = param.tel
      this.dialogForm.contacts = param.contacts
      this.dialogForm.status = param.status == 1 ? true : false
    }
  },
  mounted() {},

  methods: {
    reset(){
      this.$router.go(-1)
    },
    submitForm() {
      if(this.type == 'add'){
        let param = {
          user_name: this.dialogForm.user_name,
          key: this.dialogForm.key,
          password: this.dialogForm.password,
          address: this.dialogForm.address,
          tel: this.dialogForm.tel,
          status: this.dialogForm.status ? 1 : 0,
          contacts: this.dialogForm.contacts
        }
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              createSupApi(param).then(res => {
                if(res && res.code){
                  this.$message.success('添加成功')
                  this.$router.go(-1)
                }else{
                  Message.error(res.msg)
                }
              })
            })
          }
        })
      } else {
        let param = {
          user_name: this.dialogForm.user_name,
          key: this.dialogForm.key,
          password: this.dialogForm.password,
          address: this.dialogForm.address,
          tel: this.dialogForm.tel,
          status: this.dialogForm.status ? 1 : 0,
          contacts: this.dialogForm.contacts,
          id: this.id
        }
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              updateSup(param).then(res => {
                if(res && res.code){
                  this.$router.go(-1)
                }else{
                  Message.error(res.msg)
                }
              })
            })
          }
        })
      }
    },
  },
  beforeDestroy() {
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: 700;
}
.titlas {
  display: flex;
  align-items: center;
  margin: 20px 0;
}
.tips {
  color: red;
  font-size: 16px;
  font-weight: 600;
}
</style>
